import PropTypes from 'prop-types'
import { useAtomValue } from 'jotai'
import { rundownAtom } from '../../store/rundown.store'
import { memo } from 'react'
import { RunnerState, RundownPermission } from '@rundown-studio/types'
import { runnerAtom, runnerStateAtom } from '../../store/runner.store.js'
import { cn } from '../../utils/cn.js'
import { useRundownPermission } from '../../features/permissions/lib/use-rundown-permission.ts'

function CueItemIndex({
  cueId,
  className,
  index,
  readonly,
  loading,
  onSetNext,
  onJumpToCue,
  skipDuringShow,
}) {
  // Note: We avoid using the timestamp to avoid frequent re-renders
  const rundown = useAtomValue(rundownAtom)
  const runner = useAtomValue(runnerAtom)
  const runnerState = useAtomValue(runnerStateAtom)

  const isActive = runner?.timesnap?.cueId === cueId
  const nextCueId =
    runnerState === RunnerState.ONAIR ? runner?.nextCueId : rundown.startCueId
  const isNext = nextCueId === cueId

  const isShowCaller = useRundownPermission({
    permission: RundownPermission.SHOWCALL,
  })

  return (
    <button
      title="Cue up next"
      className={[
        'relative h-full w-full flex justify-center font-mono text-sm border-2 border-transparent rounded-sm transition-color focus:outline-hidden focus:ring-3',
        isNext && 'border-gray-400!',
        !(readonly || isNext || isActive) && 'hover:border-white/50',
        'disabled:pointer-events-none',
        skipDuringShow && 'border-gray-800! border-dashed',
        className,
      ].join(' ')}
      onClick={onSetNext}
      onDoubleClick={onJumpToCue}
      disabled={readonly || isActive || !isShowCaller || skipDuringShow}
    >
      {/* This DIV allows us to use "bg-animated" without the sticky span jumping around */}
      <div
        className={cn([
          'absolute h-full w-full rounded-sm',
          loading && 'bg-animated absolute! from-transparent to-white/20', // "absolute!" important is here as our bg-animated forces all children to be relative
        ])}
      />
      <span className={cn('sticky top-27 h-min pt-8', String(index).length > 5 && 'text-xs')}>{index}</span>
    </button>
  )
}

CueItemIndex.propTypes = {
  cueId: PropTypes.string,
  className: PropTypes.string,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  readonly: PropTypes.bool,
  loading: PropTypes.bool,
  onSetNext: PropTypes.func,
  onJumpToCue: PropTypes.func,
}

export default memo(CueItemIndex)
